import { initialState } from "src/slices/facility-forms-management/dashboard/dashboard-initial-state";
import { dashboardLayoutCountSelector } from "src/slices/facility-forms-management/dashboard/dashboard-selector";
import { dashboardSlice } from "src/slices/facility-forms-management/dashboard/dashboard-slices";
export { initialState };
export default dashboardSlice.reducer;

export { dashboardLayoutCountSelector };
